<template>
  <div class="measureFilterPills">
    <neb-pill-group :items="filterLabels"
      wrap
      itemsClearable
      @clear="onClear"
      @clear-all="$emit('clear-all')"
    ></neb-pill-group>
  </div>
</template>

<script>
import {
  includes,
  isNull,
  isEmpty,
  isUndefined,
  tail,
  camelCase,
  capitalize,
  split,
  kebabCase
} from 'lodash'

const displayFilterKeys = [
  'topics', 'keywords', 'customProperties',
  'collection', 'savedSearch', 'quickInsight'
]

export default {
  name: 'MeasureFilterPills',

  props: {
    filters: {
      type: Object,
      default: () => ({})
    },
    collectionOptions: {
      type: Array,
      default: () => []
    },
    savedSearchOptions: {
      type: Array,
      default: () => []
    },
    quickInsightOptions: {
      type: Array,
      default: () => []
    }
  },

  computed: {
    applicableFilters () {
      return Object.keys(this.filters)
        .filter(key => includes(displayFilterKeys, key))
        .filter(key =>
          !isNull(this.filters[key]) &&
          !isEmpty(this.filters[key]) &&
          !isUndefined(this.filters[key])
        )
        .reduce((obj, key) => {
          obj[key] = this.filters[key]
          return obj
        }, {})
    },
    filterLabels () {
      return Object.keys(this.applicableFilters)
        .map(key => {
          if (Array.isArray(this.filters[key])) {
            return this.filters[key]
              .map(v => `${this.formatKey(key)}: ${this.humanizeValue(key, v)}`)
          } else {
            return `${this.formatKey(key)}: ${this.humanizeValue(key, this.filters[key])}`
          }
        })
        .reduce((acc, item) => {
          if (Array.isArray(item)) {
            item.forEach(v => { acc.push(v) })
          } else {
            acc.push(item)
          }

          return acc
        }, [])
    }
  },

  methods: {
    onClear ({ item }) {
      const splitItem = item.split(':')

      let key, value

      if (splitItem.length > 2) {
        key = splitItem[0].trim()
        value = tail(splitItem).join(':').trim()
      } else {
        [ key, value ] = splitItem
      }

      this.$emit('clear', { key: camelCase(key), value })
    },
    humanizeQuickInsight (value) {
      const qi = this.quickInsightOptions.find(qi => String(qi.pk) === value)

      return qi ? qi.name : ''
    },
    humanizeValue (key, value) {
      switch (key) {
        case 'collection':
          return this.collectionOptions.find(c => c.value === String(value)).label
        case 'savedSearch':
          return this.getSavedSearchLabel(value)
        case 'quickInsight':
          return this.humanizeQuickInsight(value)
        default: return value
      }
    },
    getSavedSearchLabel (v) {
      const obj = this.savedSearchOptions.find(ss => ss.value === String(v))
      if (obj !== undefined) {
        return obj.label || 'Unknown'
      } else {
        return 'Loading...'
      }
    },
    formatKey (key) {
      return capitalize(
        split(
          kebabCase(key),
          '-'
        ).join(' ')
      )
    }
  }
}
</script>

<style lang="scss">
.measureFilterPills {
  padding-left: 20px;
  padding-bottom: 5px;
}
</style>
